const _temp0 = require("./_layout.styl");
module.exports = {
  "_layout": _temp0
}